// Build a stable, content-agnostic key that does not change during streaming.
export function stableMessageKey(message, threadKey = "") {
  if (message?.__stableKey) return message.__stableKey;
  if (message?.id) return `id:${message.id}`;
  if (message?.uuid) return `uuid:${message.uuid}`;

  const timestamp = message?.createdAt ? Date.parse(message.createdAt) : NaN;
  if (Number.isFinite(timestamp)) {
    return `ts:${threadKey}:${message?.sender || ""}:${timestamp}`;
  }

  if (!message.__localKey) {
    message.__localKey = `tmp:${threadKey}:${Math.random().toString(36).slice(2)}`;
  }
  return message.__localKey;
}

export function makeDomIdFactory(threadKey = "") {
  const keyToId = new Map();
  const used = new Set();
  const gen = () => {
    let value;
    do {
      value = `m-${Math.random().toString(36).slice(2, 10)}`;
    } while (used.has(value));
    used.add(value);
    return value;
  };

  return (message) => {
    if (message?.__stableKey) return message.__stableKey;

    const key = stableMessageKey(message, threadKey);
    let id = keyToId.get(key);
    if (!id) {
      id = key.startsWith("id:") || key.startsWith("uuid:")
        ? key.replace(/[:]/g, "-")
        : gen();
      keyToId.set(key, id);
    }
    return id;
  };
}
